import React, { useState } from 'react';
import './createProject.css'
import { toast } from 'react-toastify';
import { api } from '../../services/api';
import { useNavigate } from 'react-router-dom';

const CreateProject = () => {
  const [projectName,setProjectName] = useState('');
  const [pageNumbers,setPageNumbers] = useState('');
  const [mode,setMode] = useState('single');
  const [file,setFile] =useState(null);
  const [fileError,setFileError] = useState('');
  const [isLoading,setIsLoading] = useState(false);
  const [formError,setFormError] = useState('');
  const navigate = useNavigate();


  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if(selectedFile) {
      if(selectedFile.type ==='application/pdf') {
        setFile(selectedFile);
        setFileError('');
      } else {
        setFile(null);
        setFileError('Please upload only PDF files')
      }
    }
    e.target.value = '';
  };

  const handleDragOver = (e) =>{
    e.preventDefault();
  };

  const handleDrop = (e) =>{
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];

    if(droppedFile) {
      if(droppedFile.type ==='application/pdf') {
        setFile(droppedFile);
        setFileError('');
      }
      else{
        setFileError('Please upload only PDF files');
      }
    }
  };

  const validatePageNumbers = (value) => {
    // Ensure value is not empty or just whitespace
    if (!value.trim()) return false;
  
    // Regex pattern for numbers and ranges like 1,2-5,100,200-250
    const pattern = /^(\d+(-\d+)?)(,\s*\d+(-\d+)?)*$/;
    return pattern.test(value);
  };
  

  const handleSubmit = async(e) =>{
    e.preventDefault();
    setFormError('');

    if(!projectName.trim()) {
      setFormError('Project name is required');
      return;
    }

    if(pageNumbers && !validatePageNumbers(pageNumbers)) {
      setFormError('Invalid page numbers format. Please use format like: 1,5,18-22')
      return;
    }

    if(!file) {
      setFormError('Please upload a PDF file');
      return;
    }

    const createdBy = JSON.parse(localStorage.getItem('user'));
    const created_by = createdBy?.user_id
    if (!created_by) {
      setFormError('User not logged in. Please log in again.');
      return;
    }

    const formData = new FormData();
    formData.append('projectName',projectName);
    formData.append('pageNumber',pageNumbers);
    formData.append('mode',mode);
    formData.append('inputFile',file);
    // formData.append('userId',created_by);
    setIsLoading(true);
    try {
      const response = await api.projects.createProject(formData);
      if(response?.data?.status ==='success'){
        toast.success('Project created successfully!');
        setProjectName('');
        setPageNumbers('');
        setMode('single');
        setFile(null);
        navigate('/home/manageProject');
      }
    } catch (error) {
      setFormError('Failed to create project. Please try again.');
    }finally {
      setIsLoading(false);
    }
  };

    return (
      <div className='main-wrapper'>
      <form className='create-project-forms' onSubmit={handleSubmit}>
        <div className='create-project-container'>
          {/* Left side - Form fields */}
          <div className='create-project-form'>
            <div className='project-form-head'>Create Project</div>
            <div className='form-content'>
              <div className="project_name">
                <label className="project-form-label">Project Name<span className="required">*</span></label>
                <input 
                  type="text" 
                  placeholder="Enter Project Name"
                  value={projectName}
                  onChange={(e) => setProjectName(e.target.value)}
                  required
                />
              </div>
              
              <div className="project_number">
                <label className="project-form-label">Page Numbers for Extraction (Example 1,5,18-22)<span className="required">*</span></label>
                <input 
                  type="text" 
                  placeholder="Enter Page Number for Extraction"
                  value={pageNumbers}
                  onChange={(e) => setPageNumbers(e.target.value)}
                  required
                />
              </div>
              
              <div className="mode-selection">
                <label className="project-form-label">Mode</label>
                <div className="d-flex">
                  <div className="form-check">
                    <input 
                      className="form-check-input" 
                      type="radio" 
                      name="extractionMode" 
                      id="singleMode" 
                      value="single" 
                      checked={mode === 'single'}
                      onChange={() => setMode('single')}
                    />
                    <label className="form-check-label" htmlFor="singleMode">
                    Single
                    </label>
                  </div>
                  <div className="form-check">
                    <input 
                      className="form-check-input" 
                      type="radio" 
                      name="extractionMode" 
                      id="multipleMode" 
                      value="multiple" 
                      checked={mode === 'multiple'}
                      onChange={() => setMode('multiple')}
                    />
                    <label className="form-check-label" htmlFor="multipleMode">
                      Multiple
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Right side - File upload */}
          <div className='preview'>
            <div 
              className="drag-drop"
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              <label className="project-form-label">Upload File</label>
              <div className='upload-icon'>
                <input
                  type="file"
                  id="file-upload"
                  style={{ display: 'none' }}
                  accept=".pdf"
                  onChange={handleFileChange}
                />
                <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
                  <img src='/assets/icons/upload.svg' alt="Upload icon"/>
                  <p className="drag-drop-text">
                    <span>Browse</span> or drag and drop PDF file here
                  </p>
                </label>
                {file && (
                  <div className="selected-file">
                    Selected: {file.name}
                  </div>
                )}
                {fileError && (
                  <div className="file-error">
                    {fileError}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        
        {/* Error message */}
        {formError && (
          <div className="alert alert-danger">
            {formError}
          </div>
        )}
        
        {/* Centered button below both sections */}
        <div className='btn-wrapper'>
          <button 
            type="submit" 
            className="btn btn-primary btn-create-project"
            disabled={isLoading}
          >
            {isLoading ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </form>
    </div>
  );
  }

export default CreateProject